import React, { useEffect, useState } from 'react';
import { PageTitle, Button } from '../../components';
import {
    Card,
    CardBody,
    Form,
    Label,
    FormGroup,
    Input,
    Table,
    Row,
    Col,
    Pagination,
    PaginationItem,
    PaginationLink,
} from 'reactstrap';
import { useForm } from 'react-hook-form';
import { InvoiceSearchDto, InvoicingDto, PagingDto, PaymentSearchDto } from '../../types';
import { PaymentTypes, PaymentType } from '../../common/Data';
import { invoiceService } from '../../services/InvoiceService';
import { toast } from 'react-toastify';
import InvoiceEmailsTable from './InvoiceEmailsTable';
import { generateYears } from '../../common/Utils';
import qs from 'qs';

const SendInvoiceEmails = () => {
    const [invoices, setInvoices] = useState<InvoicingDto[]>();
    const [paging, setPaging] = useState<PagingDto>({
        pageNumber: 1,
        maxPageSize: null,
        pageSize: 100,
    });
    const [search, setSearch] = useState<InvoiceSearchDto>({
        institutionId: null,
        invoiceNumber: null,
        invoiceType: null,
        paymentType: null,
        year: new Date().getFullYear().toString(),
        status: null,
        paging: paging,
    });

    const [total, setTotal] = useState(0);

    const [reload, setReload] = useState(false);

    const onSubmit = (formData) => {
        setSearch({
            ...search,
            year: formData.fiscalYear,
        });
    };

    const reloadInvoices = () => {
        setInvoices(undefined);
        setReload(true);
    };

    useEffect(() => {
        const getData = () => {
            const toastId = toast.info('Loading...', {
                closeOnClick: false,
                draggable: false,
                autoClose: false,
            });

            invoiceService
                .getUnsentInvoices({
                    ...search,
                    paging: paging,
                })
                .then((response) => {
                    setInvoices(response.invoices);
                    setTotal(response.total);
                    toast.update(toastId, {
                        type: 'success',
                        render: 'Invoices loaded successfully.',
                    });
                })
                .catch(() => {
                    toast.update(toastId, {
                        type: 'error',
                        render: 'Failed to load invoices.',
                    });
                });
        };

        getData();
    }, [setInvoices, paging, search, reload]);

    const { register, handleSubmit } = useForm();

    return (
        <>
            <PageTitle title="Send Invoice Emails" />

            <Card>
                <CardBody>
                    <Row>
                        <Col>
                            <Form onSubmit={handleSubmit(onSubmit)} inline>
                                <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                                    <Label for="fiscalYear" className="mr-sm-2">
                                        Fiscal Year
                                    </Label>
                                    <Input
                                        type="select"
                                        innerRef={register()}
                                        name="fiscalYear"
                                        defaultValue={new Date().getFullYear()}
                                    >
                                        <option value={''}>Select...</option>
                                        {generateYears().map((ct) => (
                                            <option key={ct} value={ct}>
                                                {ct}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                                <div>
                                    <Button type="submit">Search</Button>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                    <div className="mt-3">
                        <h3>Unsent Emails</h3>
                    </div>
                </CardBody>
                {invoices && <InvoiceEmailsTable invoices={invoices} onSave={() => reloadInvoices()} />}
                {!invoices && (
                    <Table>
                        <tr>
                            <td>Loading Results</td>
                        </tr>
                    </Table>
                )}
                <CardBody>
                    <h4>Total: {total}</h4>
                    <Pagination size="sm" aria-label="Invoice Navigation">
                        <PaginationItem disabled={paging.pageNumber === 1}>
                            <PaginationLink
                                previous
                                href=""
                                onClick={() => {
                                    reloadInvoices();
                                    setPaging({ ...paging, pageNumber: paging.pageNumber - 1 });
                                }}
                            />
                        </PaginationItem>
                        <PaginationItem>
                            <PaginationLink
                                next
                                href=""
                                onClick={() => {
                                    reloadInvoices();
                                    setPaging({ ...paging, pageNumber: paging.pageNumber + 1 });
                                }}
                            />
                        </PaginationItem>
                    </Pagination>
                </CardBody>
            </Card>
        </>
    );
};

export default SendInvoiceEmails;
